<template>
  <div class="auditPR">
    <el-button type="primary" v-if="info.status === 11802" class="signature" @click="auditVisible(info)">审核</el-button>   
      <el-dialog title="审核" :visible.sync="dialogFormVisible" :modal="false">
        <el-form :model="form" :rules="formRoules" ref="form">
          <el-form-item label="审核状态" :label-width="formLabelWidth" prop="auditStatus">
            <el-select style="width: 80%" v-model="form.auditStatus" placeholder="请选择审核状态">
              <el-option label="通过" value="1"></el-option>
              <el-option label="拒绝" value="-1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核意见" :label-width="formLabelWidth" prop="cause">
            <el-input style="width: 80%" type="textarea" :rows="3" placeholder="请输入审核意见" v-model="form.cause" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="audit">确 定</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  // prescriptionReview,
  getDoctorInfo,
} from "@/api";
import {
  prescriptionReview,
  prescriptionPdf
} from "@/api/doctor";
import util from "@/utils";

  export default {
    props: ['info'],
    data() {
      return {
        form: {
          auditStatus: "",
          cause: "",
        },
        userType:util.getStore("userType"),
        dialogFormVisible: false,
        showButton: false,

        formRoules: {
          auditStatus: [
            {
              required: true,
              message: "请选择状态",
              trigger: "blur",
            },
          ],
          cause: [
            {
              required: true,
              message: "请输入审核意见",
              trigger: "blur",
            },
          ],
        },
        formLabelWidth: "120px",
        userInfoAuditStatus:''   //药师基本信息是否审核通过
      }
    },

  mounted() {
    // //一级待审核2
    // if(this.info.status === 2 && this.userType == 1){
    //  this.showButton= true;
    // }
    // //二级待审核3
    //   if(this.info.status === 6 && this.userType == 2){
    //  this.showButton= true;
    // }
    this.getUserInfo() //获取药师基本信息是否审核通过的状态
  },
   computed: {
   },
    methods:{
        /*
     * 提示信息
     * */
      elementTips: function (type, message) {
        const $t = "";
        this.$message({
          showClose: true,
          message: message,
          type: type,
        });
      },
      auditVisible(info) {
        this.dialogFormVisible = true;
        this.prescriptionId = info.id;
      },
      /**
       * 审核
       */
      audit() {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              const params = {
                status: this.form.auditStatus,
                cause: this.form.cause,
                prescriptionId: this.prescriptionId,
              };
              let res = await prescriptionReview(params);
              if (res.code == 1) {
                this.elementTips("success", res.message);
                location. reload()
                this.form.auditStatus = "";
                this.form.cause = "";
                this.showButton=false
                this.getPdf()
              } else {
                this.elementTips("warning", res.message);
              }
              this.dialogFormVisible = false;
            } catch (error) {
              console.log(error);
            }
          }
        });
      },

      async getPdf() {
      try {
        let data = {
          prescriptionId: this.prescriptionId,
        };
        await prescriptionPdf(data);
      } catch (error) {
        console.log(error);
      }
    },

      async getUserInfo() {  //用于获取药师个人信息审核状态
      try {
        const params = {
          id: util.getStore("user_id"),
        };
        let res = await getDoctorInfo(params);
        if (res.success) {
          const {status} = res.result
          this.userInfoAuditStatus =status 
        }
      } catch (error) {
        console.log(error);
      }
    },
    }
   }
</script>

<style lang="scss" scoped>
.auditPR{
  position: fixed;
  right: 10%;
  bottom: 40%;
 .signature {
      align-content: center;
      width: 80px;
      margin: 0 auto;
    }
}
</style>


